import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import EditMassMessage2 from './EditMassMessage2';

const EditMassMessageGate = props => {
  const flags = useFlags();
  if (flags.events) return <EditMassMessage2 {...props} />;
  return null;
};

export default EditMassMessageGate;
